export const messageStatus = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARN: 'warn',
    INFO: 'info',
    REMOVE: 'remove'
};
